import styled from "styled-components";
import { responsive } from "../../../../../../styles/constants.style";

export const CreateDeliverableWrapper = styled.div`
  .radio-container {
    padding: 16px 16px 0px 16px;
    ${responsive.MOBILE`
        padding: 0 16px 16px 16px;
    `}
  }

  .MuiFormGroup-root {
    margin-top: 0px;
  }

  .MuiGrid2-root {
    padding-right: 16px;
    margin-top: 24px;

    ${responsive.TABLET_PORTRAIT`
          &:nth-child(1), &:nth-child(2) {
            margin-top: 0px;
          }
          &:nth-child(n+3) {
            margin-top: 24px;
          }
        `}
    ${responsive.MOBILE`
        padding-right: 0;
          &:nth-child(1) {
            margin-top: 0px;
            padding-right: 0;
          }
          &:nth-child(n+2) {
            margin-top: 16px;
            }
        `}
  }

  .MuiGrid2-container {
    padding: 0px;
    margin-top: 0;
  }
`;
